export default (menuSelector) => {
  if (typeof menuSelector == 'undefined') {
    menuSelector = '.js-navbar-megamenu';
  }
  if ($(menuSelector).length) {
    (($) => {
      const menu = $(menuSelector);
      const dropdownSelector = '.dropdown';
      const collapseSelector = '.js-mega-menu-links a';
      const dropdownSubMenuSelector = '.js-dropdown-submenu';
      const collapseLinks = menu.find(collapseSelector);
      const collapsedElements = menu.find('.collapse');

      let dropdownTimer;
      let collapseTimer;
      const showDelay = 200;
      const hideDelay = 300;

      collapsedElements.hide();

      $(menu).on('mouseenter', dropdownSelector, (e) => {
        clearTimeout(dropdownTimer);
        dropdownTimer = setTimeout(() => {
          const element = $(e.target);

          // show first collapse of dropdown
          $('.collapse:first-child', element.next('.dropdown-menu')).show();

          if (!element.closest(dropdownSelector).hasClass('show')) {
            element.dropdown('toggle');
          }
        }, showDelay);
      });

      $(menu).on('mouseleave', dropdownSelector, (e) => {
        clearTimeout(dropdownTimer);
        dropdownTimer = setTimeout(() => {
          const element = $(e.target);
          if (element.closest(dropdownSelector).hasClass('show')) {
            element.dropdown('toggle');
          }
          collapsedElements.hide();
          collapseLinks.removeClass('show').attr('aria-expanded', 'false');
        }, hideDelay);
      });

      $(menu).on('show.bs.dropdown', dropdownSelector, () => {
        clearTimeout(dropdownTimer);
      });

      $(menu).on('mouseenter', collapseSelector, (e) => {
        clearTimeout(collapseTimer);
        collapseTimer = setTimeout(() => {
          const element = $(e.target);
          if ('toggle' === element.data('toggle') && !element.hasClass('show') && element.data('target')) {
            collapsedElements.hide();
            collapseLinks.removeClass('show').attr('aria-expanded', 'false');
            element.addClass('show').attr('aria-expanded', 'true');
            $(element.data('target')).show();
          }
        }, showDelay);
      });

      $(menu).on('mouseenter', dropdownSubMenuSelector, () => {
        clearTimeout(collapseTimer);
      });

      // Try to give a clickable Megamenue headline
      let meagaclick = true;
      $(menu)
        .find('> .dropdown > a')
        .on('touchstart', () => {
          meagaclick = false;
        });
      $(menu)
        .find('> .dropdown > a')
        .on('touchmove', () => {
          meagaclick = true;
        });
      $(menu)
        .find('> .dropdown > a')
        .on('click', (event) => {
          if (meagaclick) {
            location.href = $(event.target).attr('href');
          }
        });
    })(jQuery);
  }
};
